import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreModule } from './core/core.module';
import { AppRoutingModule } from './app-routing.module';
import { NumberOnlyDirective } from 'src/app/servicos/number.directive';
import { LocationStrategy, HashLocationStrategy, DatePipe, CommonModule } from '@angular/common';

@NgModule({
  declarations: [AppComponent, NumberOnlyDirective],
  imports: [BrowserModule, CommonModule, AppRoutingModule, CoreModule, BrowserAnimationsModule],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    DatePipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
